import { render, staticRenderFns } from "./HeaderDefault.vue?vue&type=template&id=2337987e&scoped=true&"
import script from "./HeaderDefault.vue?vue&type=script&lang=ts&"
export * from "./HeaderDefault.vue?vue&type=script&lang=ts&"
import style0 from "./HeaderDefault.vue?vue&type=style&index=0&id=2337987e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2337987e",
  null
  
)

export default component.exports